import React, { useEffect } from 'react'

import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { useDocPreview } from 'hooks/useDocPreview'
import { usePDFLoading } from 'hooks/usePDFLoading'
import { PDF_MIME_TYPE } from 'constants/docUploadConstant'
import PDFView from 'components/PDFView'

import ImagePreviewActions from 'components/ImagePreviewActions'

const UploadPreview = () => {
    const { preview, setIsLoading, setLoadingProgress, onClearPreview, openEditPreview, closeDialog } = useDocPreview()
    const previewProps = usePDFLoading(preview)
    const { base64Data, mimeType } = preview
    const { src } = previewProps

    const handleEdit = () => {
        openEditPreview(preview, false)
    }

    const handleDelete = () => {
        onClearPreview()
        closeDialog()
    }

    useEffect(() => {
        if (mimeType !== PDF_MIME_TYPE && base64Data) {
            setLoadingProgress(100)

            setTimeout(() => {
                setIsLoading(false)
            }, 500)
        }
    }, [base64Data, mimeType, setIsLoading, setLoadingProgress])

    return (
        <Box
            sx={{
                width: '100%',
                m: '0 auto',
                maxWidth: 500,
                pb: 7,
                px: { xs: 2, md: 0 }
            }}
        >
            {mimeType === PDF_MIME_TYPE ? (
                <PDFView {...previewProps} />
            ) : (
                <>
                    <Box>
                        <img src={src} alt="Upload preview" width="100%" />
                    </Box>
                    <ImagePreviewActions mimeType={mimeType} handleEdit={handleEdit} handleDelete={handleDelete} />
                </>
            )}
        </Box>
    )
}

UploadPreview.propTypes = {
    base64Data: PropTypes.string,
    mimeType: PropTypes.string
}

export default UploadPreview
